import apiHandler from "../core/apiHandler";

const cashWithdrawalApi = apiHandler("cash/withdrawals");

export default cashWithdrawalApi;